import * as SCConst from "./SCConst";
import { showStdResult, showIndicator, isConfigField } from "./SCUtil";

/* Returns the names of all results belonging to a particular category. */
export function getResultNames(displayOL, mstIDsObj, catID) {
    let strArray = [];

    const displayOLContents = JSON.parse(JSON.stringify(displayOL));

    for (let i = 0; i < displayOLContents.length; i++) {
        if (displayOLContents[i].catID === catID) {
            if (showStdResult(mstIDsObj, displayOLContents[i].resID)) {
                strArray.push(displayOLContents[i].name);
            }
        }
    }

    return strArray;
}

/* Returns the name of the result corresponding with stdResID */
export function getResultName(displayOL, stdResID) {
    let resultName = "";

    const displayOLContents = JSON.parse(JSON.stringify(displayOL));

    let stop = false;
    let i = 0;

    while (i < displayOLContents.length && !stop) {
        if (displayOLContents[i].resID === stdResID) {
            resultName = displayOLContents[i].name;
            stop = true;
        }
        i++;
    }

    return resultName;
}

/* Returns the number of indicators comprising the result corresponding with stdResID */
export function getResultNumInds(displayOL, stdResID) {
    let numInds = 0;

    const displayOLContents = JSON.parse(JSON.stringify(displayOL));

    let stop = false;
    let i = 0;

    while (i < displayOLContents.length && !stop) {
        if (displayOLContents[i].resID === stdResID) {
            numInds = displayOLContents[i].indIDs.length - 1;
            stop = true;
        }
        i++;
    }

    return numInds;
}

/* Returns the display parameter array of the result corresponding with stdResID */
export function getResultDispParams(displayOL, stdResID) {
    let resultDispParams = [];

    const displayOLContents = JSON.parse(JSON.stringify(displayOL));

    let stop = false;
    let i = 0;

    while (i < displayOLContents.length && !stop) {
        if (displayOLContents[i].resID === stdResID) {
            resultDispParams = displayOLContents[i].dispParams;
            stop = true;
        }
        i++;
    }

    return resultDispParams;
}

/* Returns the IDs of all results belonging to a particular category. */
export function getResultIDs(displayOL, mstIDsObj, catID) {
    let resIDArray = [];

    const displayOLContents = JSON.parse(JSON.stringify(displayOL));

    for (let i = 0; i < displayOLContents.length; i++) {
        if (displayOLContents[i].catID === catID) {
            if (showStdResult(mstIDsObj, displayOLContents[i].resID)) {
                resIDArray.push(displayOLContents[i].resID);
            }
        }
    }

    return resIDArray;
}

/* Returns a category name given a master ID. */
export function getCategoryName(catMstID, catInfo, mstIDsObj) {
    let categoryName = "";

    const catMstIDs = mstIDsObj[SCConst.catMstIDs];
    const catInfoContents = JSON.parse(JSON.stringify(catInfo));
    const catNames = catInfoContents[SCConst.catNames];

    let i = 1;
    while (i < catMstIDs.length && categoryName === "") {
        if (catMstIDs[i] === catMstID) {
            categoryName = catNames[i];
        }
        i++;
    }

    return categoryName;
}

/* Returns the names of all indicators that can be represented graphically for a particular category. */
export function getIndicatorNames(mstIDsObj, indInfo, catID) {
    let strArray = [];

    const indInfoContents = JSON.parse(JSON.stringify(indInfo));
    const indCanGraph = indInfoContents[SCConst.indCanGraph];
    const indNames = indInfoContents[SCConst.indNames];
    const indCats = indInfoContents[SCConst.indCats];

    for (let i = 0; i < indCanGraph.length; i++) {
        if (indCanGraph[i] && indCats[i] === catID && showIndicator(mstIDsObj, i)) {
            strArray.push(indNames[i]);
        }
    }

    return strArray;
}

/* Returns an indictor name given a master ID. */
export function getIndicatorName(indMstID, indInfo, mstIDsObj) {
    let indicatorName = "";

    const indMstIDs = mstIDsObj[SCConst.indMstIDs];
    const indInfoContents = JSON.parse(JSON.stringify(indInfo));
    const indNames = indInfoContents[SCConst.indNames];

    let i = 1;
    while (i < indMstIDs.length && indicatorName === "") {
        if (indMstIDs[i] === indMstID) {
            indicatorName = indNames[i];
        }
        i++;
    }

    return indicatorName;
}

/* Returns the number of items the indicator is distributed across. For example,
   The number of STI positive people is a single field, so its numItems is 1
   whereas the number of VMMCs done/performed is broken down into 11 different
   age groups, so its numItems is 11. */
export function getIndicatorNumItems(indMstID, indInfo, mstIDsObj) {
    let indicatorNumItems = 1;

    const indMstIDs = mstIDsObj[SCConst.indMstIDs];
    const indInfoContents = JSON.parse(JSON.stringify(indInfo));
    const numItemsPerInd = indInfoContents[SCConst.numItemsPerInd];

    let stop = false;
    let i = 1;
    while (i < indMstIDs.length && !stop) {
        if (indMstIDs[i] === indMstID) {
            indicatorNumItems = numItemsPerInd[i];
            stop = true;
        }

        i++;
    }

    return indicatorNumItems;
}

/* Returns the value an indicator should take on if there is no real data for it. For example,
   the number of HIV positive people might be -1. We can then look at this value and
   substitute for it as appropriate in editors, etc. */
export function getIndicatorNoDataValue(indMstID, indInfo, mstIDsObj) {
    let noDataValue = SCConst.noData;

    const indMstIDs = mstIDsObj[SCConst.indMstIDs];
    const indInfoContents = JSON.parse(JSON.stringify(indInfo));
    const noDataValues = indInfoContents[SCConst.indNoDataValues];

    let stop = false;
    let i = 1;
    while (i < indMstIDs.length && !stop) {
        if (indMstIDs[i] === indMstID) {
            noDataValue = noDataValues[i];
            stop = true;
        }

        i++;
    }

    return noDataValue;
}

/* Returns the IDs of all indicators that can be represented graphically for a particular category. */
export function getIndicatorIDs(mstIDsObj, indInfo, catID) {
    const indInfoContents = JSON.parse(JSON.stringify(indInfo));
    const indCanGraph = indInfoContents[SCConst.indCanGraph];
    const indCats = indInfoContents[SCConst.indCats];
    let indIDArray = [];

    for (let i = 0; i < indCanGraph.length; i++) {
        if (indCanGraph[i] && indCats[i] === catID && showIndicator(mstIDsObj, i)) {
            indIDArray.push(i);
        }
    }

    return indIDArray;
}

export function SC_onCheckboxChange(
    checked,
    event,
    name,
    caption,
    info,
    config,
    configExtra,
    siteInfo,
    countryObjList,
    selectedCountryCode,
    successFn
) {
    let varName = info[SCConst.varName];
    let currID1 = info[SCConst.currID1];
    let currID2 = info[SCConst.currID2];
    const sitesIncluded = config[SCConst.sitesIncluded];
    const siteInfoContents = JSON.parse(JSON.stringify(siteInfo));

    /* Arrays can be 2d or less. If the second dimension is defined, assume it's a 2d array.
       Otherwise, if the first dimension isn't defined, assume it's a 1d array, etc.

       For 1d or 2d arrays, a currID of 0 means the user checked "All". If so, make sure
       all items are (un)checked accordingly.

       examples of 2d arrays:
           SNUsIncluded (province (currID1) x SNU (currID2))

       examples of 1d arrays:
           provincesIncluded
           sitesIncluded
    */
    if (typeof currID2 !== "undefined") {
        config[varName][currID1][currID2] = checked;

        if (currID2 === SCConst.all) {
            const array = config[varName][currID1];

            for (let i = 1; i < array.length; i++) {
                config[varName][currID1][i] = checked;
            }

            /* If all SNUs are (un)checked under a given province, then (un)check all sites
               under all SNUs for that province. */
            if (varName === SCConst.SNUsIncluded) {
                let provinceID = currID1;

                for (let j = SCConst.all; j < sitesIncluded.length; j++) {
                    if (provinceID === getSiteProvince(siteInfoContents, j)) {
                        config[SCConst.sitesIncluded][j] = checked;
                    }
                }
            }
        } else {
        /* If something other than 'All' was clicked, ... */
            /* If it's being unchecked, make sure 'All' is unchecked. */
            if (checked === false) {
                config[varName][currID1][SCConst.all] = false;
            } else {
            /* Otherwise, it's being checked. If everything except 'All' is now checked, recheck 'All'. */
                const array = config[varName][currID1];
                let allItemsChecked = true;

                let i = 1;

                while (i < array.length && allItemsChecked) {
                    if (!config[varName][currID1][i]) {
                        allItemsChecked = false;
                    }

                    i++;
                }

                if (allItemsChecked) {
                    config[varName][currID1][SCConst.all] = true;
                }
            }

            /* If one SNU is (un)checked, then (un)check all sites under the
               selected SNU for the selected province. */
            if (varName === SCConst.SNUsIncluded) {
                let provinceID = currID1;
                let SNU_ID = currID2;

                for (let j = 1; j < sitesIncluded.length; j++) {
                    if (
                        provinceID === getSiteProvince(siteInfoContents, j) &&
                        SNU_ID === getSiteSNU(siteInfoContents, j)
                    ) {
                        config[SCConst.sitesIncluded][j] = checked;
                    }
                }

                /* Uncheck 'All' sites if we just unchecked a SNU. */
                if (!checked) {
                    config[SCConst.sitesIncluded][SCConst.all] = checked;
                } else {
                /* Otherwise, if all sites are now checked, make sure 'All' is checked. */
                    let allSitesChecked = true;

                    let i = 1;

                    while (i < sitesIncluded.length && allSitesChecked) {
                        if (!sitesIncluded[i]) {
                            allSitesChecked = false;
                        }

                        i++;
                    }

                    if (allSitesChecked) {
                        config[SCConst.sitesIncluded][SCConst.all] = true;
                    }
                }
            }
        }
    } else if (typeof currID1 !== "undefined") {
        if (isConfigField(varName)) {
            config[varName][currID1] = checked;

            /* Note that while this code may be used for provinces, it will not get used for sites
               because sites have a special onCheckboxChange for the 'All' option.
             */
            if (currID1 === SCConst.all) {
                const array = config[varName];

                for (let i = 1; i < array.length; i++) {
                    config[varName][i] = checked;
                }

                /* If all provinces are (un)checked, then (un)check all SNUS and sites
                   under all provinces. */
                if (varName === SCConst.provincesIncluded) {
                    const provincesIncluded = config[SCConst.provincesIncluded];

                    for (let j = SCConst.all; j < provincesIncluded.length; j++) {
                        const SNUsIncluded = config[SCConst.SNUsIncluded][j];

                        for (let k = SCConst.all; k < SNUsIncluded.length; k++) {
                            config[SCConst.SNUsIncluded][j][k] = checked;
                        }
                    }

                    for (let j = SCConst.all; j < sitesIncluded.length; j++) {
                        config[SCConst.sitesIncluded][j] = checked;
                    }
                }
            } else {
            /* If something other than 'All' was clicked, ... */
                /* If it's being unchecked, make sure 'All' is unchecked. */
                if (checked === false) {
                    config[varName][SCConst.all] = false;
                } else {
                /* Otherwise, it's being checked. If everything except 'All' is now checked, recheck 'All'. */
                    const array = config[varName];
                    let allItemsChecked = true;

                    let i = 1;

                    while (i < array.length && allItemsChecked) {
                        if (!config[varName][i]) {
                            allItemsChecked = false;
                        }

                        i++;
                    }

                    if (allItemsChecked) {
                        config[varName][SCConst.all] = true;
                    }
                }

                /* If one province was (un)checked, then (un)check all SNUs and sites
                   under the selected province. */
                if (varName === SCConst.provincesIncluded) {
                    let provinceID = currID1;
                    const SNUsIncluded = config[SCConst.SNUsIncluded][provinceID];

                    for (let j = SCConst.all; j < SNUsIncluded.length; j++) {
                        config[SCConst.SNUsIncluded][provinceID][j] = checked;
                    }

                    for (let j = 1; j < sitesIncluded.length; j++) {
                        if (provinceID === getSiteProvince(siteInfoContents, j)) {
                            config[SCConst.sitesIncluded][j] = checked;
                        }
                    }

                    /* Uncheck 'All' sites if we just unchecked a province. */
                    if (!checked) {
                        config[SCConst.sitesIncluded][SCConst.all] = checked;
                    } else {
                    /* Otherwise, if all sites are now checked, make sure 'All' is checked. */
                        let allSitesChecked = true;

                        let i = 1;

                        while (i < sitesIncluded.length && allSitesChecked) {
                            if (!sitesIncluded[i]) {
                                allSitesChecked = false;
                            }

                            i++;
                        }

                        if (allSitesChecked) {
                            config[SCConst.sitesIncluded][SCConst.all] = true;
                        }
                    }
                }
            }
        }
    } else {
        config[varName] = checked;
    }

    successFn(config);
}

/* Determines if a SNU is in a province */
export function SNU_InProvince(SNU_ID, provinceID, countryObjList, selectedCountryCode) {
    const countryObj = getCountryObj(countryObjList, selectedCountryCode);
    const provinceObj = countryObj.provinces[provinceID];
    const SNU_ObjList = provinceObj.snus;

    let i = 0;
    let foundSNU = false;
    while (i <= SNU_ObjList.length - 1 && !foundSNU) {
        foundSNU = true;
        i++;
    }

    return --i;
}

export function getSiteSNU(siteInfo, siteID) {
    const siteInfoContents = JSON.parse(JSON.stringify(siteInfo));

    return siteInfoContents.SNU_CurrIDs[siteID];
}

export function getSiteProvince(siteInfo, siteID) {
    const siteInfoContents = JSON.parse(JSON.stringify(siteInfo));

    return siteInfoContents.provCurrIDs[siteID];
}

/* The desktop version does not have separate 'All' checkboxes for all sites within a particular
   province and SNU. Instead of saving the state of all sites under each province and SNU, we run
   this function to determine if 'All' should be checked or not.

   sitesDisplayed tells us if a site should be displayed based on the user's selected characteristics,
   provinces, and SNUs. The server normally populates this for us. However, we won't be querying the
   server for the configOptObj until the user clicks Save at the top of the LocationsDrawer, so
   sitesDisplayed won't reflect changes to provinces and SNUs the user made in this drawer.
   Therefore, we need to check sitesDisplayed, provincesIncluded, AND SNUsIncluded. */
export function getAllSitesIncluded(config, siteInfo, provCurrID, SNU_CurrID) {
    let allSitesIncluded = true;

    const configContents = JSON.parse(JSON.stringify(config));
    const sitesIncluded = configContents[SCConst.sitesIncluded];
    const sitesDisplayed = configContents[SCConst.sitesDisplayed];
    const provincesIncluded = configContents[SCConst.provincesIncluded];
    const SNUsIncluded = configContents[SCConst.SNUsIncluded];
    const siteInfoContents = JSON.parse(JSON.stringify(siteInfo));

    let i = 1;
    while (i < sitesIncluded.length && allSitesIncluded) {
        if (
            sitesDisplayed[i] &&
            provincesIncluded[provCurrID] &&
            SNUsIncluded[provCurrID][SNU_CurrID] &&
            getSiteProvince(siteInfoContents, i) === provCurrID &&
            getSiteSNU(siteInfoContents, i) === SNU_CurrID
        ) {
            if (sitesIncluded[i] === false) {
                allSitesIncluded = false;
            }
        }
        i++;
    }

    return allSitesIncluded;
}

/* Returns true if a SNU is mapped to at least one site and can be displayed.

   sitesDisplayed tells us if a site should be displayed based on the user's selected characteristics,
   provinces, and SNUs. The server normally populates this for us. However, we won't be querying the
   server for the configOptObj until the user clicks Save at the top of the Location drawer, so
   sitesDisplayed won't reflect changes to provinces and SNUs the user made in this drawer.
   Therefore, we need to check sitesDisplayed, provincesIncluded, AND SNUsIncluded. */
export function hasSitesToDisplay(config, siteInfo, provCurrID, SNU_CurrID) {
    let foundSite = false;

    const configContents = JSON.parse(JSON.stringify(config));
    const sitesIncluded = configContents[SCConst.sitesIncluded];
    const sitesDisplayed = configContents[SCConst.sitesDisplayed];
    const provincesIncluded = configContents[SCConst.provincesIncluded];
    const SNUsIncluded = configContents[SCConst.SNUsIncluded];
    const siteInfoContents = JSON.parse(JSON.stringify(siteInfo));

    let i = 1;
    while (i < sitesIncluded.length && !foundSite) {
        if (
            sitesDisplayed[i] &&
            provincesIncluded[provCurrID] &&
            SNUsIncluded[provCurrID][SNU_CurrID] &&
            getSiteProvince(siteInfoContents, i) === provCurrID &&
            getSiteSNU(siteInfoContents, i) === SNU_CurrID
        ) {
            foundSite = true;
        }
        i++;
    }

    return foundSite;
}

/* Tells us if we can show a result as a line graph or not. Graphs that show level (site/SNU/province)
   along the x-axis should never be shown as a line. */
export function canShowGraphAsLine(config, configExtra, displayOL, mstIDsObj) {
    let canShowLine = true;

    const configContents = JSON.parse(JSON.stringify(config));
    const configExtraContents = JSON.parse(JSON.stringify(configExtra));
    const displayOLContents = JSON.parse(JSON.stringify(displayOL));
    const mstIDsObjContents = JSON.parse(JSON.stringify(mstIDsObj));
    const xAxisVar = configContents[SCConst.xAxisVar];
    const resultPlotType = configExtraContents.resultPlotType;
    const stdResID = configExtraContents.stdResID;

    /* These should never be shown as a line:
           Additional staffing needed for optimum operation by site 1
           VMMC daily persFac, by site                             2
           Number of VMMC done, by site                             24
	       Number of VMMC done, by age group                        25
	       Number of VMMC done, by simple age group                 26
	       Number of VMMC done, by surgical method                  27
	       Follow-up rate by site                                   12
	       Adverse events rate by severity, by site                 13
	       STI and referral by site                                 14
	       Daily productivity index by site                         20
	       Monthly productivity index by site                       21
	       Custom, IF the x-axis variable is LEVEL */
    if (resultPlotType === SCConst.standardPlotType) {
        // if (((stdResID >= 1) && (stdResID <= 2)) ||
        //     ((stdResID >= 12) && (stdResID <= 14)) ||
        //     ((stdResID >= 20) && (stdResID <= 21)) ||
        //     ((stdResID >= 24) && (stdResID <= 27))) {
        //         canShowLine = false;
        // }
        const resultDispParams = getResultDispParams(displayOLContents, stdResID);
        const dispParamCurrID = getDisplayParamCurrID(mstIDsObjContents, SCConst.canBeLineGraphMstID);
        canShowLine = dispParamInArray(resultDispParams, dispParamCurrID);
    } else {
        if (xAxisVar === SCConst.xAxisLevel) {
            canShowLine = false;
        }
    }

    return canShowLine;
}

/* Tells us if we can show a result as a bar graph or not. */

export function canShowGraphAsBar(configExtra, displayOL, mstIDsObj) {
    let canShowBar = true;

    const configExtraContents = JSON.parse(JSON.stringify(configExtra));
    const displayOLContents = JSON.parse(JSON.stringify(displayOL));
    const mstIDsObjContents = JSON.parse(JSON.stringify(mstIDsObj));
    const resultPlotType = configExtraContents.resultPlotType;
    const stdResID = configExtraContents.stdResID;

    /* These should never be shown as a bar:
           VMMC persFac, over time       3  (shows a time frame with clusters of sites as groups of bars)
           Number of VMMC done, over time 28 (shows a time frame with clusters of sites as groups of bars)
    */
    if (resultPlotType === SCConst.standardPlotType) {
        // if ((stdResID === 3) ||
        //     (stdResID === 28)) {
        //         canShowBar = false;
        // }
        const resultDispParams = getResultDispParams(displayOLContents, stdResID);
        const dispParamCurrID = getDisplayParamCurrID(mstIDsObjContents, SCConst.canBeBarGraphMstID);
        canShowBar = dispParamInArray(resultDispParams, dispParamCurrID);
    }

    return canShowBar;
}

/* Time type 1: For these results, the user selects a single month/quarter/half/year and moves from one to the
   next via buttons under the graph.

   Time type 2: For these results. the user selects a timeframe (ex: Feb 2015 to Jan 2017), and we display the
   graph over this timeframe (no buttons under graph for traversing). */
export function isTimeType1StdRes(displayOL, mstIDsObj, stdResCurrID) {
    const displayOLContents = JSON.parse(JSON.stringify(displayOL));
    const mstIDsObjContents = JSON.parse(JSON.stringify(mstIDsObj));

    /* Follow-up rate by site					        12
	   Adverse events rate						        13
	   STIs and referral by site				        14
	   Number of HIV tests done and update of testing	15
	   Number of HIV+ and rate							16
	   Enrolled care and treatment rate				    17
	   Performance against target by site				18
	   Utilization rate by site						    19
	   Daily productivity index						    20
	   Monthly productivity index						21 */
    // return (stdResCurrID >= 12) && (stdResCurrID <= 21);

    const resultDispParams = getResultDispParams(displayOLContents, stdResCurrID);
    const dispParamCurrID = getDisplayParamCurrID(mstIDsObjContents, SCConst.timeType1MstID);
    const timeType1StdRes = dispParamInArray(resultDispParams, dispParamCurrID);

    return timeType1StdRes;
}

/* Returns all standard results that have dual axes. */
export function isDualAxesStdRes(displayOL, mstIDsObj, stdResCurrID) {
    const displayOLContents = JSON.parse(JSON.stringify(displayOL));
    const mstIDsObjContents = JSON.parse(JSON.stringify(mstIDsObj));

    /* Number of HIV tests done and update of testing 15
	   Number of HIV+ and rate                        16
	   Enrolled care and treatment and rate           17
	   Performance against target by site             18
	   Utilization rate by site                       19
	   Demand creation                                22
	   Overall performance and productivity           23 */
    // return ((stdResCurrID >= 15) && (stdResCurrID <= 19)) || ((stdResCurrID >= 22) && (stdResCurrID <= 23));

    const resultDispParams = getResultDispParams(displayOLContents, stdResCurrID);
    const dispParamCurrID = getDisplayParamCurrID(mstIDsObjContents, SCConst.dualAxesResultMstID);
    const dualAxesStdRes = dispParamInArray(resultDispParams, dispParamCurrID);

    return dualAxesStdRes;
}

/* Returns the current ID of the display parameter from the server given the master ID. */
export function getDisplayParamCurrID(mstIDsObj, dispParamMstID) {
    let currID = 0;

    const mstIDsObjContents = JSON.parse(JSON.stringify(mstIDsObj));
    const displayParamMstIDs = mstIDsObjContents.displayParamMstIDs;

    let stop = false;
    let i = 1;
    while (i <= displayParamMstIDs.length && !stop) {
        if (displayParamMstIDs[i] === dispParamMstID) {
            currID = i;
            stop = true;
        }
        i++;
    }

    return currID;
}

/* Returns true if the display parameter is in the display parameter set of the result display
   and false otherwise. */
export function dispParamInArray(dispParamArray, dispParamCurrID) {
    let foundDisplayParam = false;

    let i = 1;
    while (i <= dispParamArray.length && !foundDisplayParam) {
        if (dispParamArray[i] === dispParamCurrID) {
            foundDisplayParam = true;
        }
        i++;
    }

    return foundDisplayParam;
}

/* Used to determine what the chart type radio group should default to based upon the result we want
   to show. Do not pull the standard result ID from the configExtra object because we are assuming it
   has not been set into that object yet. */
export function getDefaultChartType(stdResID, config, configExtra, displayOL, mstIDsObj) {
    if (!isDualAxesStdRes(displayOL, mstIDsObj, stdResID)) {
        if (canShowGraphAsLine(config, configExtra, displayOL, mstIDsObj)) {
            /* Line, bar, table; default to line. */
            return SCConst.line;
        } else if (canShowGraphAsBar(configExtra, displayOL, mstIDsObj)) {
            /* Bar, table; default to bar */
            return SCConst.bar;
        } else {
            return -1;
        }
    } else {
        /* Dual axis, table; default to dual axis */
        return SCConst.dualAxis;
    }
}

export function getArrayAsOneBased(zeroBasedArray) {
    let oneBasedArray = zeroBasedArray.splice(1, zeroBasedArray.length - 1);

    return oneBasedArray;
}

export function getSiteCurrID(mstID, mstIDsObj) {
    const siteMstIDs = mstIDsObj[SCConst.siteMstIDs];

    let siteCurrID = 0;

    let foundSite = false;
    let i = 1;
    while (i < siteMstIDs.length && !foundSite) {
        if (siteMstIDs[i] === mstID) {
            foundSite = true;
            siteCurrID = i;
        }
        i++;
    }

    return siteCurrID;
}

/* Loops through a country object and returns the indices of the province, snu, and site (respectively)
   for the first site we find. */
export function getFirstSiteIndices(countryObj) {
    let indices = [-1, -1, -1];

    let foundSite = false;

    let i = 0;
    let provinces = countryObj.provinces;

    while (i < provinces.length && !foundSite) {
        let j = 0;
        let SNUs = provinces[i].snus;

        while (j < SNUs.length && !foundSite) {
            let sites = SNUs[j].sites;

            if (sites.length > 0) {
                indices[0] = i; // province index
                indices[1] = j; // SNU index
                indices[2] = 0; // site index
                foundSite = true;
            }

            j++;
        }

        i++;
    }

    return indices;
}

export function getSiteMstID(countryObj, provinceIdx, SNU_Idx, siteIdx) {
    let siteMstID = -1;

    let provinceObj = null;

    if (countryObj === null) {
        provinceObj = null;
    } else if (countryObj.provinces.length > 0) {
        provinceObj = countryObj.provinces[provinceIdx];
    }

    let SNU_Obj = null;

    if (provinceObj === null) {
        SNU_Obj = null;
    } else if (provinceObj.snus.length > 0) {
        SNU_Obj = provinceObj.snus[SNU_Idx];
    }

    let siteObj = null;

    if (SNU_Obj === null) {
        siteObj = null;
    } else if (SNU_Obj.sites.length > 0) {
        siteObj = SNU_Obj.sites[siteIdx];
    }

    if (siteObj !== null) {
        siteMstID = siteObj.mstID;
    }

    return siteMstID;
}

export function getCountryNames(countryObjList) {
    if (countryObjList !== null) {
        let countryNames = [];

        for (let i = 0; i < countryObjList.length; i++) {
            const countryName = countryObjList[i].name;
            countryNames.push(countryName);
        }

        return countryNames;
    } else {
        return null;
    }
}

export function getCountryMstIDs(countryObjList) {
    if (countryObjList !== null) {
        let countryMstIDs = [];

        for (let i = 0; i < countryObjList.length; i++) {
            const countryCode = countryObjList[i].mstID;
            countryMstIDs.push(countryCode);
        }

        return countryMstIDs;
    } else {
        return null;
    }
}

export function getCountryOLIndex(countryObjList, countryCode) {
    if (countryObjList !== null) {
        let foundCountry = false;
        let i = 0;

        while (i < countryObjList.length && !foundCountry) {
            const countryCodeL = countryObjList[i].mstID;

            if (countryCodeL === countryCode) {
                foundCountry = true;
            }

            i++;
        }

        return i - 1;
    } else {
        return null;
    }
}

export function getCountryObj(countryObjList, countryCode) {
    if (countryObjList !== null) {
        let foundCountry = false;
        let i = 0;

        while (i < countryObjList.length && !foundCountry) {
            const countryCodeL = countryObjList[i].mstID;

            if (countryCodeL === countryCode) {
                foundCountry = true;
            }
            i++;
        }

        return countryObjList[i - 1];
    } else {
        return null;
    }
}

export function convertDelphiObjectListToJSON(countryObjList) {
    let countryOL = [];
    for (let i = 0; i < countryObjList.length; i++) {
        let country = countryObjList[i];

        let o = {};

        o = {
            name: country.name,
            mstID: country.mstID,
            provinces: [],
        };

        let provinceOL = [];
        for (let j = 0; j < country["provinceObjList"].length; j++) {
            let province = country["provinceObjList"][j];

            let o = {};

            o = {
                name: province.name,
                mstID: province.mstID,
                snus: [],
            };

            let snuOL = [];
            for (let k = 0; k < province["SNU_ObjList"].length; k++) {
                let snu = province["SNU_ObjList"][k];

                let o = {};

                o = {
                    name: snu.name,
                    mstID: snu.mstID,
                    sites: [],
                };

                let sitesOL = [];
                for (let l = 0; l < snu["siteDBObjList"].length; l++) {
                    let site = snu["siteDBObjList"][l];

                    let o = {};

                    o = {
                        name: site.name,
                        mstID: site.mstID,
                    };

                    sitesOL.push(o);
                }

                o.sites = sitesOL;
                snuOL.push(o);
            }

            o.snus = snuOL;
            provinceOL.push(o);
        }

        o.provinces = provinceOL;
        countryOL.push(o);
    }

    console.log(countryOL);
    return countryOL;
}

export function getUserCountryObjList(isGuestBool, countryObjList, allowedCountryMstIDs) {
    let countryObjListClone = JSON.parse(JSON.stringify(countryObjList));

    const numCountries = countryObjListClone.length;

    /* For now, if a user is signed in as a non-guest, and sample country is their
       allowed country, then they should be granted access to all countries. Eventually,
       we will change this so that users will be granted acess to all countries listed
       under them instead. When this happens, use isAllowedCountryWhenNotGuest */
    // const sampleCountryAllowed = () => {
    //     let i = 0;
    //     let countryAllowed = false;
    //
    //     while ((i < allowedCountryMstIDs.length) && (!countryAllowed)) {
    //         countryAllowed = (allowedCountryMstIDs[i] === SCConst.countryCodeSampleCountry);
    //         i++;
    //     }
    //
    //     return countryAllowed;
    // };

    const isAllowedCountryWhenNotGuest = (countryMstID) => {
        let i = 0;
        let countryAllowed = false;

        while (i < allowedCountryMstIDs.length && !countryAllowed) {
            /* You should never see sample country if you are signed in as a non-guest.  */
            countryAllowed =
                allowedCountryMstIDs[i] === countryMstID && countryMstID !== SCConst.countryCodeSampleCountry;
            i++;
        }

        return countryAllowed;
    };

    /* Remove all countries that shouldn't be shown from the cloned countryobjList. */
    for (let i = numCountries; i >= 1; i--) {
        let countryObj = countryObjListClone[i - 1];

        if (
            (isGuestBool && countryObj.mstID !== SCConst.countryCodeSampleCountry) ||
            (!isGuestBool && !isAllowedCountryWhenNotGuest(countryObj.mstID))
        ) {
            // mark eSwatini -- for some reason, there was a "!" in front of the commented out sampleCountryAllowed below
            //((!isGuestBool) && ((sampleCountryAllowed()) &&
            //(countryObj.mstID === SCConst.countryCodeSampleCountry)))) {

            countryObjListClone.splice(i - 1, 1);
        }
    }

    return countryObjListClone;
}

export function getStartingCountryCode(userCountryObjList) {
    return userCountryObjList[0].mstID;
}
